export default __webpack_public_path__ + "static/media/35.3e292ef3.png";